import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useStateContext } from "../contexts/ContextProvider";
import SideBarProductCard from "../subComponent/SideBarProductCard";

const ProductSidebar = () => {
  const { cartItem, total, getTotal } = useStateContext();

  useEffect(() => {
    getTotal();
  }, [cartItem]);

  const navigate = useNavigate();
  return (
    <Component>
      <Header>
        <h4>SubTotal</h4>
        <p>${parseFloat(total).toFixed(2)}</p>
        <button
          onClick={() => navigate("/cart")}
          style={{
            cursor: "pointer",
          }}
        >
          Go to Cart
        </button>
      </Header>

      <Body>
        {cartItem
          ?.slice()
          .reverse()
          .map((cart, i) => (
            <SideBarProductCard cart={cart} cartItems={cartItem} key={i} />
          ))}
      </Body>
    </Component>
  );
};

export default ProductSidebar;

const Component = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Header = styled.div`
  border-bottom: 1px solid black;
  height: 50px;
  line-height: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 20px;
  margin-top: 10px;
  h4 {
    margin-bottom: 10px;
  }
  p {
    font-size: 14px;
    font-weight: 500;
  }
  button {
    padding: 2px 0px;
    width: 90%;
    border-radius: 40px;
    border: 1px solid #e364d0;
    background: transparent;
    box-shadow: 3px 5px 5px 0px rgba(0, 0, 0, 0.14);
    -webkit-box-shadow: 3px 5px 5px 0px rgba(0, 0, 0, 0.14);
    -moz-box-shadow: 3px 5px 5px 0px rgba(0, 0, 0, 0.14);
  }
`;

const Body = styled.div`
  height: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`;
